/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, August 2020
 */

import React from 'react';
import { FlowBlock } from '@staffino/model';
import BlockFactory from './block-factory';

type Props = {
  block: FlowBlock;
};

const ContainerBox = ({ block }: Props) => (
  <>
    {('children' in block ? block.children : []).map((child) => (
      <BlockFactory block={child} key={child.id} />
    ))}
  </>
);

export default ContainerBox;
